import { render, staticRenderFns } from "./TheMenuLogin.vue?vue&type=template&id=4e2c5c1c&scoped=true&"
import script from "./TheMenuLogin.vue?vue&type=script&lang=ts&"
export * from "./TheMenuLogin.vue?vue&type=script&lang=ts&"
import style0 from "./TheMenuLogin.vue?vue&type=style&index=0&id=4e2c5c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c5c1c",
  null
  
)

export default component.exports